import { render } from "./VideoGalleryComponent.vue?vue&type=template&id=2401a1b5&scoped=true"
import script from "./VideoGalleryComponent.vue?vue&type=script&lang=js"
export * from "./VideoGalleryComponent.vue?vue&type=script&lang=js"

import "./VideoGalleryComponent.vue?vue&type=style&index=0&id=2401a1b5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2401a1b5"]])

export default __exports__